@if (errors['obj.date_received']) {
  <div class="row">
    @for (error of errors['obj.date_received']; track error) {
      @for (errorMsg of error.msg; track errorMsg) {
        @if (errorMsg === 'error.before.konsi.date') {
          <div class="col-md-12">
            <div class="alert red_alert">
              Das Wareneingangs Datum darf bei Konsibeständen nicht mehr als 90 Tage zurück liegen.
            </div>
          </div>
        }
      }
    }
  </div>
}

@if (errors['obj.amount']) {
  <div class="row">
    @for (error of errors['obj.amount']; track error) {
      @for (errorMsg of error.msg; track errorMsg) {
        <div class="col-md-12">
          <div class="alert red_alert">
            @switch (errorMsg) {
              @case ('error.negative.balance') {
                Es können nicht mehr Materialien entnommen werden, als vorhanden sind.
              }
              @case ('error.zero.balance') {
                Es sollte mindestens eine Einheit transferiert werden.
              }
              @case ('error.positive.only') {
                Es können nur positive Mengen eingebucht werden.
              }
              @default {
                Unbekannter Fehler beim &Uuml;bertragen des Formulars.
              }
            }
          </div>
        </div>
      }
    }
  </div>
}

@if (errors['obj.note']) {
  <div class="row">
    @for (error of errors['obj.note']; track error) {
      @for (errorMsg of error.msg; track errorMsg) {
        @if (errorMsg === 'error.negative.not.commented') {
          <div class="col-md-12">
            <div class="alert red_alert">
              Bei negativen Mengen muss eine Notiz angegeben werden!
            </div>
          </div>
        }
      }
    }
  </div>
}

@if (!!errors['obj.variation_id']) {
  <div class="row">
    <div class="col-md-12">
      <div class="alert red_alert">Variation konnte nicht gefunden werden.</div>
    </div>
  </div>
}
